import { Table } from '../Table/Table';
import { Box } from '@mui/material';
import { Text } from '../Text/Text';
import { noDataMessageContainerSx } from '../../styles/Global.style';
import { Copy } from '../../copy/Copy';

export const LeaderboardTable = ({ title, leaderboard, columns }) => {
  return leaderboard.users.length ? (
    <Table
      columns={columns}
      rows={leaderboard.users}
      positionTitle={title}
      total={leaderboard.total}
      showPosition
    />
  ) : (
    <Box component="div" sx={noDataMessageContainerSx}>
      <Text text={Copy.generate('LeaderboardTable.noActivities')} />
    </Box>
  );
};
